/**
 * 语言 统一路由拦截
 */
import Cookies from '@/utils/js-cookie'
import { languages } from './district'
import { loadLanguageAsync } from './utils'

let LangInterceptor = {}

LangInterceptor.install = (Vue) => {
  Vue.mixin({
    beforeRouteEnter (to, from, next) {
      let currentLanguage = ''
      //languages指的是当前地区使用的语言列表
      //Cookies{{ $t('w1154') }}cookies{{ $t('w1155') }}
      // 先从 query 中取语言标识，并判断是否属于语言列表中的语言
      if (to.query.language && languages.indexOf(to.query.language) > -1) {
        currentLanguage = to.query.language
      }
      // 如果 query 中没有语言标识，则从 cookie 中获取，如果 cookie 中也没有，则取默认语言
      if (!currentLanguage) {
        let cookieLang =  Cookies.get('language')

        if (cookieLang && languages.indexOf(cookieLang) > -1) {
          currentLanguage = cookieLang
        } else {
          currentLanguage = languages[0]
        }
      }
      //静态js语言文件懒加载，后进行页面跳转
      loadLanguageAsync(currentLanguage).then(() => {
        next()
      })
    }
  })
}

export default LangInterceptor
